import { Component, OnInit } from '@angular/core';
import { RequestsServices } from '../../services/requests.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from '../../services/toaster.service';
import { CEPServices } from '../../services/cep.service';
import { UserService } from '../../services/user.service';
import { checkboxValidator } from '../../utils/validators/checkbox.validator';
import { phoneValidator } from '../../utils/validators/phone.validator';
import * as masks from '../../utils/masks/';
import { AddressService } from '../../services/address.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EstablishmentsService } from '../../services/establishments.service';
import  brazilStates from '../../../assets/shared/data/brazilStates.json';
@Component({
  selector: 'own-partnership-form',
  templateUrl: './own-partnership-form.component.html',
  styleUrls: ['./own-partnership-form.component.scss'],
  providers: [CEPServices, UserService, AddressService],
})
export class OwnPartnershipFormComponent implements OnInit {

  cepMask = masks.cepMask;
  phoneMask = masks.phoneMask;
  isLoading = true;
  addressId = null;
  loggedUser = null;
  activeAccount = null;
  categories = [];
  cepLoading = false;
  isLoadingPage = true;
  establishmentId = null;
  statesList = brazilStates.list;
  modalitiesOptions = [
    { name: 'A empresa vende por meio da internet.', selected: false, value: 1 },
    { name: 'A empresa possui estabelecimentos físicos.', selected: false, value: 2 },
    { name: 'A empresa vai até o cliente.', selected: false, value: 3 },
  ];

  groupOptions = [
    { text: 'Cupom', id: 'standard' },
    { text: 'Online', id: 'online' },
  ];

  ckEditorConfig = {
    fillEmptyBlocks: false,
    allowedContent: false,
    forcePasteAsPlainText: true,
    pasteFilter: 'plain-text',
    clipboard_defaultContentType: 'text',
    enterMode: 1, // On enter key press: CKEDITOR.ENTER_BR = 2, CKEDITOR.ENTER_P = 1
    toolbarGroups: [
      { name: 'basicstyles', groups: ['basicstyles'] },
      { name: 'links', groups: ['links'] },
      { name: 'paragraph', groups: ['list', 'indent'] },
      { name: 'blocks', groups: ['blocks', 'align'] },
      { name: 'cleanup', groups: ['cleanup'] },
      { name: 'undo', groups: ['undo'] },
    ],
    removeButtons: 'Subscript,Anchor,Superscript,CreateDiv',
    removePlugins: 'elementspath',
    extraPlugins: 'divarea'
  };

  // Form Groups
  form: FormGroup;
  offer: FormGroup;
  modalities: FormArray;
  contact: FormGroup;
  address: FormGroup;

  // Form Controls
  establishment_name = new FormControl();
  about = new FormControl();
  url_website = new FormControl();
  category = new FormControl();
  group = new FormControl();

  // Offer Controls
  offer_title = new FormControl();
  offer_term = new FormControl();

  // Contact Controls
  contact_name = new FormControl();
  contact_phone = new FormControl();

  // Address Controls
  address_nameUnit = new FormControl();
  address_neighborhood = new FormControl();
  address_zipcode = new FormControl();
  address_city = new FormControl();
  address_state = new FormControl();
  address_street = new FormControl();
  address_number = new FormControl();
  address_complement = new FormControl();
  address_phone = new FormControl();

  constructor(
    private request: RequestsServices,
    private toaster: ToasterService,
    private cepService: CEPServices,
    private userService: UserService,
    private addressService: AddressService,
    private establishmentService: EstablishmentsService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
  }

  ngOnInit() {
    this.getCurrentUser();
    this.getCategories().then(() => {
      this.getEstablishmentInfo(this.route.snapshot.params.id);
    });
  }

  getCurrentUser = () => {
    this.loggedUser = this.userService.getLoggedUser();
    this.activeAccount = this.userService.getLoggedAccount();
  }

  onEditorReady(e) {
    const blockTags = ['div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'li', 'blockquote', 'ul', 'ol', 'table', 'thead',
      'tbody', 'tfoot', 'td', 'th', 'br'];

    for (let i = 0; i < blockTags.length; i++) {
      e.editor.dataProcessor.writer.setRules(blockTags[i], {
        indent: false,
        breakBeforeOpen: false,
        breakAfterOpen: false,
        breakBeforeClose: false,
        breakAfterClose: false
      });
    }
  }

  getEstablishmentInfo(establishmentId) {
    if (establishmentId) {
      this.establishmentId = establishmentId;
      this.isLoadingPage = true;
      this.isLoading = true;

      this.establishmentService
        .getEstablishmentInfo(establishmentId, { 'filter[include]': 'addresses' })
        .then(establishment => {
          this.createFormControls(establishment);
          this.createFormGroups(establishment);
          this.isLoadingPage = false;
          this.isLoading = false;
          this.addressId = establishment.addresses && establishment.addresses.length ? establishment.addresses[0].id : null;
        })
        .catch((err) => {
          this.toaster.info(
            'Erro!',
            'Não foi possível carregar os dados do estabelecimento, por favor tente novamnte.',
            false,
            5000
          );
        });
    } else {
      this.createFormControls();
      this.createFormGroups();
      this.isLoadingPage = false;
      this.isLoading = false;
    }
  }

  async getCategories() {
    await this.request.get({ path: 'categories' }).then((res) => {
      const categories = res || [];
      categories.forEach(category => {
        const { id, name, title_offer_sample, text_offer_sample, _tags } = category;
        this.categories.push({ id, title_offer_sample, text_offer_sample, text: name, tags: _tags });
      });
    });
  }

  updateValidators(control, ...validators) {
    if (!validators.length) {
      this.url_website.setValue('');
    }

    control.setValidators([...validators]);
    control.updateValueAndValidity();
  }

  updateAddressValidators(...validators) {
    this.updateValidators(this.address_nameUnit, ...validators);
    this.updateValidators(this.address_nameUnit, ...validators);
    this.updateValidators(this.address_neighborhood, ...validators);
    this.updateValidators(this.address_zipcode, ...validators);
    this.updateValidators(this.address_city, ...validators);
    this.updateValidators(this.address_state, ...validators);
    this.updateValidators(this.address_street, ...validators);
    this.updateValidators(this.address_number, ...validators);
  }

  createFormGroups(establishment?) {
    this.modalities = this.buildModalitiesGroup(establishment);
    this.contact = this.buildContactGroup();
    this.address = this.buildAddressGroup();
    this.offer = this.buildOfferGroup();
    this.form = this.buildFormGroup();

    this.touchValidators();
  }

  createFormControls(establishment?) {

    if (establishment) {

      this.establishment_name.setValue(establishment.name);
      this.about.setValue(establishment.about);

      if (establishment.group) {
        this.group.setValue([this.groupOptions.find(el => el.id === establishment.group)]);
      }

      if (establishment.categoryId) {
        this.category.setValue([this.categories.find(el => el.id === establishment.categoryId)]);
      }

      if (establishment.urls) {
        this.url_website.setValue(establishment.urls.url_website);
      }

      if (establishment.offer) {
        // Offer controls
        this.offer_title.setValue(establishment.offer.title);
        this.offer_term.setValue(establishment.offer.term);

        // Contact controls
        this.contact_name.setValue(establishment.offer.contact.name);
        this.contact_phone.setValue(establishment.offer.contact.phone);
        this.updateValidators(this.contact_phone, phoneValidator);
      }

      // Address controls
      if (establishment.addresses && establishment.addresses.length) {
        this.address_nameUnit.setValue(establishment.addresses[0].nameUnit);
        this.address_neighborhood.setValue(establishment.addresses[0].neighborhood);
        this.address_zipcode.setValue(establishment.addresses[0].cep);
        this.address_city.setValue(establishment.addresses[0].county);
        const state = this.formatStateAddress(establishment.addresses[0].state);
        this.address_state.setValue(state);
        this.address_street.setValue(establishment.addresses[0].street);
        this.address_number.setValue(establishment.addresses[0].number);
        this.address_complement.setValue(establishment.addresses[0].additional);
        this.address_phone.setValue(establishment.addresses[0].telephone);
      }
    }
  }


  private formatStateAddress(stateAddress) {
    return this.statesList.filter(state => state.id === stateAddress);
  }

  buildFormGroup() {
    return this.fb.group({
      name: this.establishment_name,
      about: this.about,
      category: this.category,
      offer: this.offer,
      url_website: this.url_website,
      modalities: this.modalities,
      address: this.address,
      group: this.group,
      status: { description: 'completed', pendencies: false },
      is_own_partnership: true,
      companyId: this.activeAccount.id
    });
  }

  buildContactGroup() {
    return this.fb.group({
      name: this.contact_name,
      phone: this.contact_phone
    });
  }

  buildModalitiesGroup(establishment?) {
    const modalities = this.modalitiesOptions.map(skill => {
      return this.fb.control(skill.selected || (establishment && establishment.modalities.includes(skill.value)));
    });
    const modalitiesGroup = this.fb.array(modalities, Validators.compose([checkboxValidator]));

    modalitiesGroup.valueChanges.subscribe(() => { this.touchValidators(); });

    return modalitiesGroup;
  }

  touchValidators() {
    if (this.checkModality(1)) {
      this.updateValidators(this.url_website, Validators.required);
    } else {
      this.updateValidators(this.url_website);
    }

    if (this.checkModality(2) || this.checkModality(3)) {
      this.updateAddressValidators(Validators.required);
    } else {
      this.updateAddressValidators();
    }

  }

  buildOfferGroup() {
    return this.fb.group({
      title: this.offer_title,
      term: this.offer_term,
      contact: this.contact,
      application_name: 'Allya',
      application_slug: 'allya'
    });
  }

  buildAddressGroup() {
    return this.fb.group({
      nameUnit: this.address_nameUnit,
      neighborhood: this.address_neighborhood,
      cep: this.address_zipcode,
      county: this.address_city,
      state: this.address_state,
      street: this.address_street,
      number: this.address_number,
      additional: this.address_complement,
      telephone: this.address_phone
    });
  }

  getModalities() {
    const values = this.form.get('modalities').value;
    return values.map((selected, i) => selected ? this.modalitiesOptions[i].value : null).filter(el => el);
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  checkModality(modality: number): boolean {
    const modalities = this.getModalities();
    return modalities.indexOf(modality) > -1;
  }

  onChangeCep(value: any): void {
    const cep = value.currentTarget.value.replace(/_/g, '');

    if (cep && cep.length === 9) {
      this.cepLoading = true;
      this.cepService.getAddressByCep(cep).subscribe((place) => {
        this.isLoading = false;

        const state = this.statesList.find(el => el.id === place.uf);
        this.address.controls.neighborhood.setValue(place.bairro);
        this.address.controls.county.setValue(place.localidade);
        if(state) {
          this.address.controls.state.setValue([state]);
        } else {
          this.address.controls.state.setValue('');
        }

        this.address.controls.street.setValue(place.logradouro);

        if (place.erro) {
          this.toaster.info(
            'Cep não encontrado',
            'Verifique se o cep está correto',
            true,
            2000)
          ;
        }
      });
    }
  }

  normalizeData(data) {
    const { modalities, category, url_website, group, ...rest } = data;

    return {
      ...rest,
      modalities: this.getModalities(),
      categoryId: category ? data.category[0].id : null,
      group: group ? data.group[0].id : null,
      urls: { url_website }
    };
  }

  public normalizeAddress(address) {
    let state;
    if (address.state) {
      state = (typeof address.state === 'string') ? address.state : address.state[0].id;
    } else {
      state = '';
    }
    address.state = state;
    return address;
  }

  requestAddressGeoPoint(address) {
    let addressAsString = '';

    if (address.street) { addressAsString += address.street; }
    if (address.number) { addressAsString += ', ' + address.number; }
    if (address.neighborhood) { addressAsString += ', ' + address.neighborhood; }
    if (address.county) { addressAsString += ', ' + address.county; }
    if (address.state) { addressAsString += ', ' + address.state; }
    if (address.cep) { addressAsString += ', ' + address.cep; }

    return this.addressService.addressToGeoPoint(addressAsString);
  }

  saveAddress(address) {
    let request;

    if (this.addressId) {
      request = this.addressService.updateAddress(address, this.addressId);

    } else {
      request = this.addressService.saveAddress(address);
    }

    request.then(() => {
      this.handleSuccess(!!this.establishmentId);
    }).catch(() => {
      this.isLoading = false;
      this.toaster.info(
        'Erro!',
        'Não foi possível salvar o endereço, tente novamente!',
        false,
        5000
      );
    });
  }

  saveEstablishment({ address, ...data }) {
    let request;
    const normalizedData = this.normalizeData(data);
    const normalizedAddress = this.normalizeAddress(address);

    this.isLoading = true;

    if (this.establishmentId) {
      request = this.request.put('establishments', { ...normalizedData, id: this.establishmentId });
    } else {
      request = this.request.post('establishments', normalizedData);
    }

    request.then(establishment => {

      if (this.checkModality(2) || this.checkModality(3)) {

        this.requestAddressGeoPoint(normalizedAddress).then(location => {

          this.saveAddress({
            ...normalizedAddress,
            establishmentId: establishment.id,
            location
          });

        }).catch(() => {

          this.isLoading = false;
          this.toaster.info(
            'Erro!',
            'Não foi possível salvar o endereço, tente novamente!',
            false,
            5000
          );
        });

      } else {
        this.handleSuccess(!!this.establishmentId);
      }

    }).catch(() => {

      this.isLoading = false;
      this.toaster.error(
        'Aviso!',
        'Ocorreu um erro ao salvar o dados do estabelecimento, por favor tente novamente!',
        false,
        6000
      );
    });
  }

  submitForm(isValid, values) {
    this.markFormGroupTouched(this.form);
    if (isValid) {
      this.saveEstablishment(values);
      return;
    }

    if (this.hasCheckboxSelectError(this.modalities)) {
      this.showErrorMessage('Selecione a Modalidade do Estabelecimento!');
      return;
    }

    const requiredFieldsValidate = [
      {field: this.establishment_name, message: 'Informe o campo Nome da Empresa!'},
      {field: this.category, message: 'Selecione uma Categoria!'},
      {field: this.group, message: 'Selecione um Agrupamento!'},
      {field: this.url_website, message: 'Informe o Site da Empresa!'},
      {field: this.offer_title, message: 'Informe o Título da Proposta!'},
      {field: this.offer_term, message: 'Informe os Termos da Proposta!'},
      {field: this.contact_name, message: 'Informe o Contato!'},
      {field: this.contact_phone, message: 'Informe um Telefone para o Contato!'},
      {field: this.address_nameUnit, message: 'Informe o Nome da Unidade!'},
      {field: this.address_zipcode, message: 'Informe o CEP!'},
      {field: this.address_neighborhood, message: 'Informe o Bairro!'},
      {field: this.address_city, message: 'Informe o Município!'},
      {field: this.address_state, message: 'Selecione o Estado!'},
      {field: this.address_street, message: 'Informe a Rua!'},
      {field: this.address_number, message: 'Informe o Número!'},
    ];

    for (const requiredField of requiredFieldsValidate) {
      if (this.hasRequiredFieldError(requiredField.field)) {
        this.showErrorMessage(requiredField.message);
        return;
      }
    }
  }

  hasRequiredFieldError(field): boolean {
    return field.errors && field.errors.required;
  }

  hasCheckboxSelectError(field): boolean {
    return field.errors && field.errors.invalidCheckbox;
  }

  showErrorMessage(message) {
    this.toaster.info('Atenção', message,  false, 5000);
  }

  handleSuccess(redirect = false) {
    if (!redirect) {
      this.router.navigate(['/parcerias-exclusivas']).then(() => {
        this.toaster.success(
          'Sucesso!',
          'Parceria foi salva com sucesso!',
          true,
          5000
        );
      });
    } else {
      this.isLoading = false;
      this.toaster.success(
        'Sucesso!',
        'Parceria foi salva com sucesso!',
        true,
        5000
      );
    }
  }

}
